activ.controller("library", ["$scope", "$http", "$upload", "$location", "ngDialog",
    function($scope, $http, $upload, $location, ngDialog){

    $scope.pageTitle = "Library";

}]);
